module.exports = __webpack_public_path__ + "static/media/givelaunch_logo_1024x512.8d63a541.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/givelaunch_logo_1024x512.png
// module id = 598
// module chunks = 0